// extracted by mini-css-extract-plugin
export default {"header":"NetworkPricesHeader_header__eNJki","title":"NetworkPricesHeader_title__iGz5b"};